import  React,{  Component, ReactDOM} from 'react';
import './List.css';
import {url, VendorCard, vendorMapping, mappingKeys} from './List.consts.js'
import FormField from '../Components/FormField';
import Tabs from 'react-simpletabs';
import swal from 'sweetalert';
import Sticky from 'react-sticky-el';


var mainSection; 

const initialVendorState = {
  vendors: [],
};

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}


class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      cards: [], 
      vendors: [],
      vendorStore: [],
      loadingVendors: true,
      images: {},
      imagesLoaded: 0,
      vendorTypes: [],
      selectedVendorTypes : [""],
      data_status : {},
      igID: ""
    };
    
  }
  
  
  componentDidMount() {
    let dataRange = "ta4pafa2fataya" // topfifty
    
    // if want to load a specific vendor
    let ig = this.getQueryStringValue ('ig'), id = this.getQueryStringValue ('id')
    let specificVendor = ig || id
    if (specificVendor) {
      this.getVendor({ig: ig, id: id}) 
    } else {
      this.getVendors({dataRange: dataRange});
    }
    var el = document.querySelector("#tabs");
    console.log(el)
    this.getVendorTypes();
  }
  
  
  getQueryStringValue (key) {  
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
  } 
  
  saveToState = (data, isValid) => {
    const { name, value } = data      
    this.setState({ 
      selectedVendorTypes : [value],
      data_status : Object.assign(this.state.data_status, {[name] : isValid})
    });
    // this.getVendors({dataRange: "1lala", types: [value]})
    
  }
  saveToIgState = (data, isValid) => {
    const { name, value } = data      
    this.setState({ 
      igID : value,
      data_status : Object.assign(this.state.data_status, {[name] : isValid})
    });
    // this.getVendors({dataRange: "1lala", types: [value]})
    
  }
  
  onSelectVendorType(e) {
    var options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    // this.props.someCallback(value);
    this.setState({
      selectedVendorTypes: value
    })
  }
  
  getVendor(options) {
    this.setState({
      loadingVendors: true
    })
    var url = 'https://api.lushplans.com/_vendor?ig=lushplans'
    
    if (options.ig) {
      url = 'https://api.lushplans.com/_vendor?ig=' + options.ig.toLowerCase()
    } else {
      this.setState({
        vendorStore: [],
        vendors: []
      })
      swal("IMPORTANT!", "You must enter a valid instagram ID", "error");
      return;
    }
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw Error("Network request failed")
      }
      return response
    })
    .then(d => d.json())
    .then(d => {
      d = [d]
      for (var i=0;i<d.length;i++) {
        let images = {...this.state.images}
        images[i] = "https://wed.lushplans.com/images/def.jpg#" + new Date().getTime();;
        this.setState({images})
      } 
      
      this.getImages(d)
    },() => {
      this.setState({
        requestFailed: true
      })
      swal("IMPORTANT!", "There was an error finding that ID", "info");
    })
    
  }
  
  
  getVendorTypes(options) {
    this.setState({
      loadingVendors: true
    })
    var url = 'https://api.lushplans.com/_vendortypes'
    
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw Error("Network request failed")
      }
      return response
    })
    .then(d => d.json())
    .then(d => {
      let vendorTypes = d.map((item, index) => {
        item = item.replace(/\w\S*/g, (txt) => {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        })        
        return { label : item}
      })
      this.setState({
        vendorTypes: vendorTypes
      })
    },() => {
      this.setState({
        requestFailed: true
      })
    })
    
  }
  
  reset() {
    this.setState(initialVendorState);
  }
  
  
  getVendors (options) {
    let dataRange = options.dataRange
    let types = options.types
    var currentUrl = url + dataRange + "-" + new Date().getTime()
    if (types) {
      currentUrl += "&types=" + (types.length > 1 
        ? types.join(",,,").toLowerCase() 
        : types + ",,,test").toLowerCase()
      // currentUrl += "&types=" + (types + ",,,test").toLowerCase()
    }
    this.setState({
      loadingVendors: true
    })
    let condition = this.state.vendorStore && this.state.vendorStore.length >= 50; // 50 is default loaded
    
    let temp = this.state.vendorStore.slice()
    if (condition && !types) {
      
      switch(dataRange) {
        case "ta4pa":
        this.setState({ vendors: temp.splice(0,1)},
        () => this.getImages (this.state.vendors))
        break;
        case "ta4patahara22":
        this.setState({ vendors: temp.splice(0,3)},
        () => this.getImages (this.state.vendors))
        break;
        case "ta4pafa3va2":
        this.setState({ vendors: temp.splice(0,5) },
        () => this.getImages (this.state.vendors))
        break;
        case "ta4pata2na":
        this.setState({ vendors: temp.splice(0,10) },
        () => this.getImages (this.state.vendors))
        break;
        case "ta4patawa2nataya":
        this.setState({ vendors: temp.splice(0,20)},
        () => this.getImages (this.state.vendors))
        break;
        case "ta4pafa2fataya":
        this.setState({ vendors: temp.splice(0,50)},
        () => this.getImages (this.state.vendors))
        break;
        default:
        this.setState({
          vendors: temp
        })
      }
      return ;
    }
    
    console.log("passed loop")
    fetch(currentUrl)
    .then(response => {
      if (!response.ok) {
        throw Error("Network request failed")
      }
      return response
    })
    .then(d => d.json())
    .then(d => {
      for (var i=0;i<d.length;i++) {
        let images = {...this.state.images}
        images[i] = "https://wed.lushplans.com/images/def.jpg#" + new Date().getTime();;
        this.setState({images})
      } 
      this.getImages(d)
    },() => {
      swal("IMPORTANT!", "Not found", "info");
      this.setState({
        requestFailed: true
      })
    })
    
  }
  
  
  getImages (d) {
    console.log(d)
    if (!d || !d[0] || !d[0].id || d[0].id.length < 2) {
      this.setState({
        vendorStore: [],
        vendors: [],
        loadingVendors: false,
        requestFailed: true
      })
      swal({
        title: "Your results from the market women", 
        text: "Error. Try again",  
        allowOutsideClick: "false" ,
        allowEscapeKey: "false",
        icon: "error",
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons:{
          add: {
            text: "Add you profile",
            value: "add",
            closeModal: false
          },
          consult: "Search another"
        }
      }).then((value) => {
        switch (value) {
          case "add":
          window.open("https://vendor.lushplans.com", "", "",true)
          swal.stopLoading();
          break;
          default:
          window.location.reload();
        }
      });
      console.log("NA")
      return
    }
    
    this.setState({
      vendorStore: d,
      vendors: d
    })
    
    for (var ind=0;ind<d.length;ind++) {
      let scs = d[ind].scs
      let sc = scs[Math.floor(Math.random()*scs.length)];
      let j = ind;
      let len = d.length
      
      fetch("https://api.instagram.com/oembed/?url=http://instagram.com/p/" + sc)
      .then(response => {
        if (!response.ok) {
          throw Error("Network request failed")
        }
        return response
      })
      .then(d => d.json())
      .then(d => {
        let images = {...this.state.images}
        images[j] = images[j].indexOf("http") > -1 ? d.thumbnail_url + "#" + new Date().getTime() : this.state.images[j];
        this.setState({images})
        this.setState({
          imagesLoaded: this.state.imagesLoaded + 1
        })
        if (this.state.imagesLoaded >= len) {
          this.setState({
            loadingVendors: false
          })
          window.scrollTo(0, 100);
        }
      }, () => {
        this.setState({
          requestFailed: true
        })
      })
    }
    
  }
  
  render() {
    mainSection = !this.state.loadingVendors ? 
    (
      <div className="row mainSection">
      {this.state.vendors.map((vendor, vendorIndex) => 
        <VendorCard key={vendorIndex} {...vendor}
        key={vendorIndex}
        image={this.state.images[vendorIndex]} this={this}/>)}
        </div>
      ): (
        <div  className="mx-auto text-center mainSection" >
        <hr className="spacer"></hr>
        <div className="height">
        <img  className="img-responsive spinner" alt=""
        src="https://wed.lushplans.com/images/logo_color_spinner.gif" />
        </div>
        </div>
        
      )
      mainSection = this.state.requestFailed ?
      (
        <div className="row height mainSection">
        <br></br>
        <br></br>
        <div className="text-center col-xs-12">NOTHING FOUND</div>
        <br></br>
        </div>
      ):
      (mainSection)
      
      return (
        <div className="vendorsSection" >
        <hr className="spacer"></hr>
        <Sticky>
          <div className="search col-xs-12">
            <Tabs id="tabs">
              <Tabs.Panel title='Get single vendor with Instagram username'>
                <FormField
                field={{
                  name : "services",
                  label : "",
                  type : "text",
                  container_css : "w-100",
                  placeholder: "Enter Instagram username to find and claim",
                  meta : {
                    autocomplete : true,
                    options : []
                  }
                }}            
                value={this.state.igID}
                fieldChange={this.saveToIgState}
                />
                <button className="btn-save btn btn-primary btn-sm" id="srcBtn" disabled={this.state.igID.length < 2}
                onClick={this.getVendor.bind(this, {ig: this.state.igID, id: ""})}>Search</button>
                <a id="cta-1" href="https://vendor.lushplans.com/"  className="btn-save btn btn-primary btn-sm pull-right">Claim profile</a>
              
              </Tabs.Panel>
              <Tabs.Panel title='Search Type of vendor '>
                
                <FormField
                field={{
                  name : "services",
                  label : "",
                  type : "text",
                  container_css : "w-100",
                  placeholder: "Type a vendor type to find",
                  meta : {
                    autocomplete : true,
                    multiple : true,
                    options : this.state.vendorTypes
                  }
                }}            
                value={this.state.selectedVendorTypes[0]}
                fieldChange={this.saveToState}
                />
                <button className="btn-save btn btn-primary btn-sm" id="srcBtn" disabled={this.state.selectedVendorTypes[0].length < 2}
                onClick={this.getVendors.bind(this, {dataRange: "1lala", types: this.state.selectedVendorTypes})}>Search</button>
                <a id="cta-1" href="./signup"  className="btn-save btn btn-primary btn-sm pull-right">Claim your vendor profile</a>
              
              </Tabs.Panel>
              <Tabs.Panel title='See top vendors'>
                <div className="row mx-auto text-center center-btns">
                  {mappingKeys.map((key, k) =>  <button k={key} type="submit" 
                  className="btn btn-sm btn-primary btn-center-block" 
                  id={key}
                  onClick={this.getVendors.bind(this, {dataRange: key})}
                  disabled={this.state.loadingVendors}>{vendorMapping[key]}</button>
                  )}
                </div>
              </Tabs.Panel>
            </Tabs>
          </div>
        </Sticky>
        {/* <hr></hr> */}
        {mainSection}
        
        </div>
      )
      
    }
  };
  
  export default App;
  


// WEBPACK FOOTER //
// ./src/List/List.js